// Keep toolbar state current; the panel is only needed after someone opens it.
import { get, set, setMany, subscribe } from "../shared/settings-store.js";
import { EXTENSIONS } from "../shared/extensions.js";
import { $ } from "./dom.js";
import { openSettings } from "./tabs.js";
import { openDevtoolsActive, clearHighlightsActive, pipActive } from "./ext-frames.js";
import { readGate } from "./read-gate.js";
import { overflowExts } from "./ext-bar.js";
import { active } from "./state.js";
import { citeOk, cardOk, citePage, makeCard } from "./card-gate.js";
let loading, opening = false;
export function initExtUI() {
	const btn = $("rv-ext"), inc = $("rv-incognito"), count = $("rv-ext-count");
	// Quick actions surfaced under a page-tool extension's row when it's enabled.
	const actions = {
		devtools: [{ label: "Open on this page", run: () => openDevtoolsActive() }],
		readaloud: [{ label: () => (readGate.reading() ? "Show the player" : "Read this page"), run: () => readGate.toggle(btn) }],
		highlighter: [
			{ label: "Make card from highlight", when: () => cardOk(active()), run: () => makeCard(active()) },
			{ label: "Cite this page", when: () => citeOk(active()), run: () => citePage(active()) },
			{ label: "Clear highlights", run: () => clearHighlightsActive() },
		],
		pip: [{ label: "Pop out video", run: () => pipActive() }],
	};

	const sync = () => {
		const n = EXTENSIONS.filter((x) => !x.quiet && get(x.key) === true).length;
		if (count) { count.hidden = n === 0; count.textContent = String(n); }
		if (inc) inc.hidden = get("incognito") !== true;
	};
	if (inc) inc.addEventListener("click", () => set("incognito", false));
	if (btn) {
		btn.setAttribute("aria-haspopup", "dialog");
		btn.addEventListener("click", async () => {
			if (opening) return; opening = true; btn.setAttribute("aria-busy", "true");
			try {
				if (!loading) loading = import(__RVM.extUIJs).catch((error) => { loading = null; throw error; });
				(await loading).openExtUI({ get, set, setMany, subscribe, openSettings, overflowExts, actions });
			} catch { alert("Couldn't load Extensions. Reload the page and try again."); }
			finally { opening = false; btn.removeAttribute("aria-busy"); }
		});
	}
	sync(); subscribe(sync);
}
